// extracted by mini-css-extract-plugin
module.exports = {"main":"styles_main__2oHBj","content":"styles_content__3cPgX","marker":"styles_marker__12doJ","image":"styles_image__2w_5K"};